import type { SyncRun } from '../types';

interface Props {
  runs: SyncRun[];
}

const STATUS_ICON: Record<SyncRun['status'], string> = {
  ok: '✅',
  running: '🔄',
  error: '❌',
};

function formatUtc(unixTs: number): string {
  const d = new Date(unixTs * 1000);
  return d.toISOString().replace('T', ' ').replace(/\.\d{3}Z$/, ' UTC');
}

function durationLabel(run: SyncRun): string {
  if (run.completed_at == null) return '—';
  const secs = run.completed_at - run.started_at;
  if (secs < 60) return `${secs}s`;
  return `${Math.floor(secs / 60)}m${secs % 60}s`;
}

function truncate(s: string, len: number): string {
  return s.length <= len ? s : s.slice(0, len - 1) + '…';
}

export function SyncRunList({ runs }: Props) {
  if (runs.length === 0) {
    return (
      <section className="sync-runs empty" aria-label="sync-runs">
        <h2>同步紀錄</h2>
        <p className="muted">尚未執行任何同步。</p>
      </section>
    );
  }
  return (
    <section className="sync-runs" aria-label="sync-runs">
      <h2>同步紀錄(近 {runs.length} 筆)</h2>
      <table>
        <thead>
          <tr>
            <th>Status</th>
            <th>Zone</th>
            <th>Started</th>
            <th>Duration</th>
            <th>Rows</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          {runs.map((r) => (
            <tr key={r.id}>
              <td>{STATUS_ICON[r.status]}</td>
              <td>{r.zone_id.slice(0, 8)}…</td>
              <td>{formatUtc(r.started_at)}</td>
              <td>{durationLabel(r)}</td>
              <td>{r.rows_upserted.toLocaleString('en-US')}</td>
              <td className="error-cell">
                {r.error_message ? truncate(r.error_message, 200) : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
